import { config } from '@services/config';
import { IndicationMetadataGetResponse } from '@lio/api-types';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const indicationMetadataQueryKey = 'indicationMetadata';
export const useIndicationMetadata = () => {
  const client = useClient();

  const result = useQuery<IndicationMetadataGetResponse, Error>({
    queryKey: [indicationMetadataQueryKey],
    queryFn: () => client.get(`indication/metadata`).json<IndicationMetadataGetResponse>(),
    ...config,
  });
  return { ...result, indicationMetadata: result.data };
};
